import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { servicesData } from "../datas/services";
import styled from "styled-components";
import colors from "../utils/colors";

const ImgWrapper = styled.p`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 2rem 0;
`;

const Image = styled.img`
    height: 10%;
    width: 40%;
`;

const Title = styled.h1`
    text-align: center;
    margin: 2rem 0;
    font-size: 2rem;
    color: ${colors.secondColor};
`;

const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 1rem;
    gap: 5rem;
    width: 100%;
`;

const ServiceDescription = styled.p`
    text-align: justify;
    width: 95%;
`;

const List = styled.ul`
    background-color: ${colors.lightBackground};
    width: 30%;
    border-radius: 1rem;
    padding: 1rem 2rem;
    gap: 0.5rem;

    @media screen and (max-width:770px) {
        width: 60%;
    }
`;

// const Form = styled.form`
//   margin-right: 0;
//   width: 70%;
  
//   @media screen and (max-width:770px) {
//     width: 100%;
// }
// `;

// const InputField = styled.input`
//   width: 50%;
//   padding: 0.8rem;
//   margin: 0.7rem;
// `;

// const SubmitButton = styled.button`
//   background-color: ${colors.background};
//   color: ${colors.textColor};
//   border: none;
//   border-radius: 0.5rem;
//   padding: 0.5rem;
//   cursor: pointer;

//   &:hover {
//     background-color: ${colors.secondColor};
//   }
// `;

const ServiceMoreLink = styled(Link)`
    display: inline-block;
    background-color: ${colors.background};
    color: ${colors.textColor};
    padding: 0.5rem 0.8rem;
    border-radius: 1.3rem;
    text-decoration: none;
    margin: 2rem;
`;

function ServiceInfo() {
    const params = useParams();
    const serviceTitle = decodeURIComponent(params.title || "");
    const service = servicesData.find(s => s.title === serviceTitle);

    if (!service) {
        return <Navigate to="/Services" replace />;
    }

    return (
        <>
            <ImgWrapper>
                <Image src={service.image} alt="" />
            </ImgWrapper>
            <Title>{service.title}</Title>

            <Container>
                <ServiceDescription>{service.description}</ServiceDescription>
                <List>
                    {service.servicesFournis.map((caracteristique, index) => (
                        <li key={index}>{caracteristique}</li>
                    ))}
                </List>
            </Container>

            <ServiceMoreLink to="/Services">Plus de services</ServiceMoreLink>

        </>
    )
}

export default ServiceInfo
